<script>
import options from "./ChatSendButton.options"
export default options
</script>

<template>
    <button @click="handleClick" :disabled="disabled" :aria-label="ariaLabel" :title="ariaLabel"
        class="nyk-chat-panel__chat-input-action-send nyk-button nyk-button--link-icon nyk-button--link-icon-circle">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 12">
            <path fill="#fff"
                d="M12.177 6a.75.75 0 0 0-.43-.677L1.671.55a.749.749 0 0 0-1.032.914l1.217 3.648L7.184 6l-5.33.888-1.216 3.648a.753.753 0 0 0 1.034.915L11.75 6.678A.752.752 0 0 0 12.177 6Z" />
        </svg>
    </button>
</template>